import { type SupportedIntegrationProductSlugs } from '../constants';
import type { ProductSlugs } from '@deque/billing-utils';

export type BaseModalProps = {
  show: boolean;
  onClose: () => void;
};

export enum InterWindowMessageType {
  REFRESH_INTEGRATION_CONNECTION = 'REFRESH_INTEGRATION_CONNECTION'
}

export type InterWindowMessageDataRefreshIntegrationConnection = {
  connection_id: string;
  product_slug:
    | SupportedIntegrationProductSlugs
    | ProductSlugs.axeAuditorIntegration;
};
export type InterWindowMessage = {
  message_type: InterWindowMessageType;
  data: InterWindowMessageDataRefreshIntegrationConnection; // OR other types for other types of messages
};
